import React, {useState, useEffect} from 'react';
import {withRouter} from "react-router-dom"
import {BodySm, TitleXl, TitleMd,  Row,  Col5, Col7} from "components/elements";
import {AboutUsPurpleSectionContainer, TitleXlContainer} from './elements';

function AboutUsPurpleSection(props) {
	const [windowWidth, setWindowWidth] = useState(false)


    useEffect(() => {
        const handleResize = () => {
            window.innerWidth < 769 ? setWindowWidth(true) : setWindowWidth(false)
			document.documentElement.clientWidth < 769 ? setWindowWidth(true) : setWindowWidth(false)
        }
    
        window.addEventListener("resize", handleResize);
		document.documentElement.addEventListener("resize", handleResize);
        handleResize();
        return () => {
			window.removeEventListener("resize", handleResize);
			document.documentElement.removeEventListener("resize", handleResize);
		}
     },[])

return(
        <AboutUsPurpleSectionContainer title="">
            <TitleXlContainer>
                <TitleXl fontWeight="900">Not to brag, but we’re a pretty big deal<span className="magenta">.</span>  </TitleXl>
            </TitleXlContainer>
            <Row  alignItems="start">
                <Col5>
                    <TitleMd>
                        Trusted by the best. Respected by our peers. 
                    </TitleMd>
                    <BodySm>
                    We work with the top 30 pharma and biotech companies. And we've had 20 years of double-digit growth. We're supported by thousands of experts across a broad range of healthcare specialties. Fast Company has ranked us #2 as the most innovative in data sciences, Cannes Lions as the #3 most creative in health and MM+M as the #1 medical marketing agency, which means we don't just do it all, we do it all really well.
                    </BodySm>
                </Col5>
                <Col7>
                {windowWidth ? <img src="./images/infographic-mbl.svg" alt="#1 Medical Marketing Agency, #2 Most innovative in data sciences, #3 Most creative in health" />
                    : <img src="./images/Infographic-desktop.svg" alt="#1 Medical Marketing Agency, #2 Most innovative in data sciences, #3 Most creative in health" />
                 }
                </Col7>
            </Row>
          
        </AboutUsPurpleSectionContainer>
    )
}

export default withRouter(AboutUsPurpleSection);
